__turbopack_context__.v({
  "login": "log-in-module-scss-module__HXrEDW__login",
});
